module.exports = __webpack_public_path__ + "media/images/lb/681-acbef4a942998d5063637ae32b11b1f4.svg";